import React from "react";
import "./HowWeWork.css";

const HowWeWork = () => {
  const steps = [
    {
      title: "Understanding Your Requirements",
      text: "We begin by understanding your vision, objectives, and expectations in detail to ensure a clear direction for the event.",
      step: 1,
    },
    {
      title: "Research & Planning",
      text: "Our team conducts detailed research and creates a well-structured plan covering concept, budget, timeline, and execution strategy.",
      step: 2,
    },
    {
      title: "Creative Concept Development",
      text: "We design unique and customized concepts that match your event type, theme, and brand identity.",
      step: 3,
    },
    {
      title: "Coordination & Execution",
      text: "From vendors to technical setup, our experienced team coordinates every element to ensure smooth and seamless execution.",
      step: 4,
    },
    {
      title: "On-Ground Management",
      text: "Our professionals manage the event on-site with precision, handling every detail so you can enjoy a stress-free experience.",
      step: 5,
    },
    {
      title: "Quality Control & Delivery",
      text: "We ensure high-quality standards, timely execution, and flawless delivery—making your event successful and memorable.",
      step: 6,
    },
  ];

  return (
    <section id="how-we-work" className="how-we-work">
      <div className="how-we-work-container">
        <div className="section-header">
          <h2 className="section-title">How Are We Working?</h2>
          <div className="title-underline"></div>
          <p className="how-we-work-intro">
            We follow a structured and detail-driven approach to deliver
            seamless event experiences. From understanding your vision to final
            execution, every step is carefully planned and professionally
            managed. Our experienced team ensures smooth coordination,
            high-quality execution, and stress-free delivery—turning your ideas
            into memorable events.
          </p>
        </div>

        <div className="how-we-work-steps">
          {steps.map((item, index) => (
            <article
              key={item.title}
              className={`how-step how-step--${
                index % 2 === 0 ? "right" : "left"
              }`}
              aria-labelledby={`how-step-title-${item.step}`}
            >
              <div className="how-step-track" aria-hidden="true">
                <div className="how-step-node">{item.step}</div>
              </div>
              <div className="how-step-column">
                <div className="how-step-content">
                  <span className="how-step-label">
                    Step {String(item.step).padStart(2, "0")}
                  </span>
                  <h3
                    className="how-step-title"
                    id={`how-step-title-${item.step}`}
                  >
                    {item.title}
                  </h3>
                  <p className="how-step-text">{item.text}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
